import type { ButtonProps } from '@launchpad-ui/components';
import { Button } from '@launchpad-ui/components';

import { useFormContext } from '../../contexts';

export function CancelButton({ type = 'button', variant = 'minimal', children = 'Cancel', ...props }: ButtonProps) {
  const form = useFormContext();

  return (
    <form.Subscribe selector={(state) => ({ isSubmitting: state.isSubmitting })}>
      {({ isSubmitting }) => (
        <Button isDisabled={isSubmitting} variant={variant} type={type} {...props}>
          {children}
        </Button>
      )}
    </form.Subscribe>
  );
}
